import { FirmwareOnboarding } from "@/components/Elemnt/Onboarding/FirmwareOnboarding";
import { useParams } from "react-router";

const FirmwareOnboardingPage = () => {
  const { appToken = "" } = useParams();
  return <FirmwareOnboarding appToken={appToken} />;
};

export default FirmwareOnboardingPage;
